module.exports = __webpack_public_path__ + "media/images/icons/apple_podcasts-eb7aad38beebf956abab359584b7686d.svg";